import { Component, signal, OnInit } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { AuthService } from 'src/auth/services/auth.service';
import { FormEvents } from 'src/shared/constants';
import { CodeTablesClient, EmailCodeDto, PersonEmailDto, ProfileClient } from 'src/shared/services/api.service';

@Component({
  standalone: false,
  selector: 'edportal-educator-contact-email',
  templateUrl: './educator-contact-email.component.html',
  styles: ``,
})
export class EducatorContactEmailComponent implements OnInit {
  addEmailMode = signal(false);
  selectedEmail = signal<PersonEmailDto | undefined>(undefined);
  dataLoaded = signal(false);
  emails = signal<PersonEmailDto[]>([]);
  emails$!: Observable<PersonEmailDto[]>;
  emailOptions = signal<EmailCodeDto[]>([]);

  constructor(
    private readonly profileClient: ProfileClient,
    private readonly codeTablesClient: CodeTablesClient,
    public authService: AuthService,
  ) {}

  ngOnInit() {
    this.loadEmails();
    this.codeTablesClient.getPersonEmailCodes().subscribe((x) => this.emailOptions.set(x));
  }

  loadEmails() {
    this.profileClient
      .getPersonsEmailInfo()
      .pipe(finalize(() => this.dataLoaded.set(true)))
      .subscribe((x) => this.emails.set(x));
  }

  enableAddEmail() {
    this.selectedEmail.set(undefined);
    this.addEmailMode.set(true);
  }

  handleFormEvent(emissionValue: FormEvents) {
    if (emissionValue == FormEvents.Cancelled) {
      this.selectedEmail.set(undefined);
      this.addEmailMode.set(false);
    } else if (emissionValue == FormEvents.Successful) {
      this.selectedEmail.set(undefined);
      this.addEmailMode.set(false);
      this.loadEmails();
    }
  }

  loadEditForm(email: PersonEmailDto) {
    this.selectedEmail.set(email);
    this.addEmailMode.set(true);
  }

  emailItemClasses(email: PersonEmailDto) {
    return {
      editing: email.personEmailId == this.selectedEmail()?.personEmailId,
    };
  }
}
